import React, {
  useState, useEffect, useCallback
} from "react";
import { withTranslation } from "react-i18next";
import {
  useDispatch,
  connect,
  useSelector
} from "react-redux";
import moment from "moment";
// eslint-disable-next-line object-curly-newline
import { Button, Row, Col } from "reactstrap";
import { AvForm, AvField } from "availity-reactstrap-validation";
import { fetchReportStart } from "store/reports/actions";
import { fetchClientsStart } from "store/client/actions";
import CustomPagination from "components/Common/CustomPagination";

import Loader from "components/Common/Loader";
import SendReportEmail from "./SendReportEmail";
import AvFieldSelect from "components/Common/AvFieldSelect";
import DownloadFileType from "./DownloadFileType";
import CountryDropDown from "components/Common/CountryDropDown";
import ClientDropDown from "components/Common/Filters/ClientDropDown";
import SearchableComponent from "pages/Transactions/Forex/internalTransfer/SearchableComponents";
import { getClients } from "apis/client";
import { getSymbols } from "apis/reports";

const ALL_SYMBOLS_OPTION = { __isAll: true };
const ALL_IBS_OPTION = { __isAll: true };
import SearchableAllAgentsDropdown from "components/Common/SearchableAllAgentsDropdown";
import usePermissions from "routes/permissions";


const isWalletBalanceVisible = (userEmail) => {
  const allowed = process.env.REACT_APP_WALLET_BALANCE_ALLOWED_EMAIL;
  if (!allowed) return true;
  return userEmail === allowed;
};

const getReportTypeOptions = (t, userEmail) => {
  const options = [
    {
      value: "deposits",
      label: t("Deposits By Login"),
    },
    {
      value: "deposit-status-fx",
      label: t("Forex Deposits Status"),
    },
    {
      value: "deposit-status",
      label: t("Wallet Deposits Status"),
    },
    {
      value: "client-deposits",
      label: t("Deposits By Client"),
    },
    {
      value: "withdrawals",
      label: t("Withdrawals By Login"),
    },
    {
      value: "withdrawals-status",
      label: t("Wallet Withdrawals Status"),
    },
    {
      value: "withdrawals-status-fx",
      label: t("Forex Withdrawals Status"),
    },
    {
      value: "client-withdrawals",
      label: t("Withdrawals By Client"),
    },
    {
      value: "daily-net-deposit",
      label: t("Daily Net Deposit"),
    },
    {
      value: "new-client-deposits",
      label: t("New Client Deposits"),
    },
    {
      value: "commission",
      label: t("Commission"),
    },
    {
      value: "credit-in",
      label: t("Credit In"),
    },
    {
      value: "credit-out",
      label: t("Credit Out"),
    },
    {
      value: "unfunded-accounts",
      label: t("Unfunded Accounts"),
    },
    {
      value: "summary",
      label: t("Deals Summary"),
    },
    {
      value: "lead-converted",
      label: t("Lead Converted"),
    },
    {
      value: "lead-call-status",
      label: t("Lead Call Status"),
    },
    {
      value: "last-login",
      label: t("Last Login"),
    },
    {
      value: "ib-summary",
      label: t("IB wise Summary"),
    },
    {
      value: "ib-total-closed-lots-by-product",
      label: t("IB Total Closed Lots by Product"),
    },
    {
      value: "ib-total-closed-lots-by-symbol",
      label: t("IB Total Closed Lots by Symbol"),
    },
    {
      value: "ib-referrals",
      label: t("IB Referrals"),
    },
    {
      value: "wallet-transactions",
      label: t("Wallet Transactions"),
    },
    {
      value: "payment-gateway",
      label: t("Payment Gateway"),
    },
  ];

  if (isWalletBalanceVisible(userEmail)) {
    options.push({
      value: "wallet-balance",
      label: t("Wallet Balance"),
    });
  }

  return options;
};

function UsersAddModal(props) {
  const dispatch = useDispatch();
  const [sizePerPage, setSizePerPage] = useState(10);
  const [selectedValues, setSelectedValues] = useState({});
  const [reportType, setReportType] = useState("");
  const [showStatus, setShowStatus] = useState(false);
  const [showGateway, setShowGateway] = useState(false);
  const [hasSearched, setHasSearched] = useState(false);
  const [clientSearchText, setClientSearchText] = useState("");
  const [symbolValue, setSymbolValue] = useState("");
  const [ibValue, setIbValue] = useState("");

  const { products, clients, clientsLoading } = useSelector((state) => ({
    products: state.dictionaryReducer?.products || {},
    clients: state.clientReducer?.clients || [],
    clientsLoading: state.clientReducer?.loading || false,
  }));
  const handleShowStatus = (type) => {
    if (type === "deposit-status" || type === "deposit-status-fx" || type === "withdrawals-status-fx" || type === "withdrawals-status" || type === "wallet-transactions" || type === "payment-gateway") {
      setShowStatus(true);
    } else {
      setShowStatus(false);
    }
  };

  const handleShowGateway = (type) => {
    if (type === "deposit-status" || type === "deposit-status-fx" || type === "withdrawals-status-fx" || type === "withdrawals-status" || type === "payment-gateway") {
      setShowGateway(true);
    } else {
      setShowGateway(false);
    }
  };


  const [isClientMenuOpen, setIsClientMenuOpen] = useState(false);

  const {
    reportsPermissions,
    userPermissions,
  } = usePermissions();

  const productTypeOptions = [
    {
      label: props.t("All"),
      value: "",
    },
    ...Object.keys(products || {})
      .filter((key) => Array.isArray(products[key]) && products[key].length > 0)
      .map((key) => ({
        label: key,
        value: key,
      })),
  ];

  const submitReportSearch = (values) => {
    const payload = {
      ...values,
      agent:
        reportsPermissions.getAssigned && !reportsPermissions.get
          ? props.userData._id
          : values.agent,
      country: values.country || selectedValues.country || "",
      customerId: values.customerId || "",
      parentId: values.parentId || "",
    };

    props.setReportColumns(values.reportType);
    dispatch(fetchReportStart(payload));
    props.setPayload({
      ...values,
      type: values.reportType,
    });
  };
  const paginationLoad = (page) => {
    dispatch(
      fetchReportStart({
        ...selectedValues,
        page,
        limit: sizePerPage,
      })
    );
  };

  useEffect(() => {
    if (hasSearched && selectedValues && selectedValues.reportType) {
      const nextValues = {
        ...selectedValues,
        limit: sizePerPage,
        page: 1,
      };
      setSelectedValues(nextValues);
      submitReportSearch(nextValues);
    }
  }, [sizePerPage]);

  const loadClients = useCallback((searchText = "") => {
    if (searchText !== "" && searchText.length >= 3) {
      dispatch(
        fetchClientsStart({
          limit: 1000,
          page: 1,
          searchText: searchText.split("@").shift(),
        })
      );
    } else if (searchText === "") {
      dispatch(
        fetchClientsStart({
          limit: 1000,
          page: 1,
        })
      );
    }
  }, [dispatch]);

  useEffect(() => {
    loadClients();
  }, [loadClients]);

  useEffect(() => {
    const debounceTimer = setTimeout(() => {
      if (clientSearchText.length >= 3) {
        loadClients(clientSearchText);
      } else if (clientSearchText === "") {
        loadClients("");
      }
    }, 400);

    return () => clearTimeout(debounceTimer);
  }, [clientSearchText, loadClients]);

  const clientOptions = [
    {
      label: props.t("All"),
      value: "",
    },
    ...clients.map((client) => ({
      value: client._id,
      label: `${client?.firstName} ${client?.lastName}`,
    })),
  ];

  const handleClientSearch = (inputValue, meta = {}) => {
    const { action } = meta;

    if (action === "input-change") {
      setClientSearchText(inputValue);
    }

    return inputValue;
  };

  const defaultValues = {
    reportType: "deposits",
    dateFrom: moment().subtract(1, "months").format("YYYY-MM-DD"),
    dateTo: moment().add(1, "day").format("YYYY-MM-DD"),
  };

  return (
    <React.Fragment>
      <div className=" me-2 mb-2">
        <div className="position-relative">
          <AvForm
            className="p-1"
            onValidSubmit={(e, v) => {
              delete v.clientSearch;
              const formValues = {
                ...selectedValues,
                ...v,
                country: selectedValues.country || "",
                limit: sizePerPage,
                page: 1,
              };
              setSelectedValues(formValues);
              setHasSearched(true);
              submitReportSearch(formValues);
            }}
            model={defaultValues}
          >
            <Row>
              <Col xs={12} md={4} lg={2}>
                <label>{props.t("Report Type")}</label>
                <AvFieldSelect
                  type="select"
                  name="reportType"
                  required
                  onChange={(e) => {
                    setReportType(e);
                    handleShowStatus(e);
                    handleShowGateway(e);
                    setSelectedValues(prev => ({
                      ...prev,
                      reportType: e,
                      country: ""
                    }));
                  }}
                  options={getReportTypeOptions(props.t, props.userData?.email)}
                  errorMessage={props.t("please select report Type")}
                  validate={{ required: { value: true } }}
                >
                </AvFieldSelect>
              </Col>
              <Col xs={12} md={4} lg={2}>
                <AvField
                  name="dateFrom"
                  label={props.t("Date From")}
                  type="date"
                  errorMessage={props.t("Select date From")}
                  validate={{ required: { value: true } }}
                />
              </Col>
              <Col xs={12} md={4} lg={2}>
                <AvField
                  name="dateTo"
                  label={props.t("Date To")}
                  type="date"
                  errorMessage={props.t("Select date To")}
                  validate={{ required: { value: true } }}
                />
              </Col>

              <Col xs={12} md={4} lg={2}>
                <AvFieldSelect
                  type="select"
                  name="agent"
                  label={props.t("Agent")}
                  value={reportsPermissions.getAssigned && !reportsPermissions.get ? props.userData._id : ""}
                  options={
                    reportsPermissions.getAssigned && !reportsPermissions.get ? (
                      [
                        {
                          label: `${props.userData.firstName} ${props.userData.lastName}`,
                          value: props.userData._id,
                        },
                      ]
                    ) : (
                      [
                        {
                          label: props.t("All"),
                          value: "",
                          defaultValues: true,
                        },
                        ...props?.salesAgent?.map((obj) => ({
                          label: `${obj.firstName} ${obj.lastName}`,
                          value: obj._id,
                        })),
                      ]
                    )
                  }
                  errorMessage={props.t("Select Agent")}
                ></AvFieldSelect>
              </Col>
              {showStatus ? <Col xs={12} md={4} lg={2}>
                <AvFieldSelect
                  name="status"
                  label={props.t("Status")}
                  type="select"
                  errorMessage={props.t("Select Status")}
                  options={[
                    {
                      label: props.t("All"),
                      value: "",
                    },
                    {
                      label: props.t("Approved"),
                      value: "APPROVED",
                    },
                    {
                      label: props.t("Rejected"),
                      value: "REJECTED",
                    },
                    {
                      label: props.t("Pending"),
                      value: "PENDING",
                    },
                  ]}
                ></AvFieldSelect>
              </Col> : null}
              {showGateway ? <Col xs={12} md={4} lg={2}>
                <AvFieldSelect
                  name="gateway"
                  label={props.t("Gateway")}
                  type="select"
                  errorMessage={props.t("Select Gateway")}
                  options={[
                    {
                      label: props.t("All"),
                      value: "",
                    },
                    {
                      label: props.t("Wire Transfer"),
                      value: "WIRE_TRANSFER",
                    },
                    {
                      label: props.t("CRYPTO"),
                      value: "CRYPTO",
                    },
                    {
                      label: props.t("HESABE"),
                      value: "HESABE",
                    },
                    {
                      label: props.t("CASH"),
                      value: "CASH",
                    },
                    {
                      label: props.t("CYRAFA PAY"),
                      value: "CYRAFA_PAY",
                    },
                  ]}
                ></AvFieldSelect>
              </Col> : null}
              {["withdrawals", "deposits"].includes(reportType) && (
                <>
                  <Col>
                    <AvField
                      name="login"
                      label={props.t("Login")}
                      type="text"
                      placeholder={props.t("Enter login")}

                      // validation (fallback safety)
                      validate={{
                        pattern: { value: "^[0-9]*$" },
                        maxLength: { value: 8 }
                      }}

                      // prevent non-numbers
                      onKeyPress={(e) => {
                        if (!/[0-9]/.test(e.key)) {
                          e.preventDefault();
                        }
                      }}

                      // enforce max length while typing
                      onInput={(e) => {
                        e.target.value = e.target.value.replace(/\D/g, "").slice(0, 8);
                      }}
                    />
                  </Col>
                  <Col>
                    <AvFieldSelect
                      name="client"
                      label={props.t("Client")}
                      type="select"
                      isLoading={clientsLoading}
                      isSearchable
                      onChange={() => setClientSearchText("")}
                      onInputChange={handleClientSearch}
                      inputValue={clientSearchText}
                      placeholder={clientsLoading ? props.t("Loading...") : props.t("Select")}
                      noOptionsMessage={() => (
                        clientsLoading
                          ? props.t("Loading...")
                          : clientSearchText.length > 0 && clientSearchText.length < 3
                            ? props.t("Type at least 3 characters")
                            : props.t("No options")
                      )}
                      errorMessage={props.t("Select client")}
                      options={clientOptions}
                    ></AvFieldSelect>
                  </Col>
                </>
              )}
              {["deposit-status-fx", "withdrawals-status-fx", "deposit-status", "withdrawals-status"].includes(reportType) && (
                <>
                  <Row>
                    <Col xs={12} md={6} lg={3}>
                      <AvFieldSelect
                        name="client"
                        label={props.t("Client")}
                        type="select"
                        isLoading={clientsLoading}
                        isSearchable
                        onChange={(selected) => {
                          setClientSearchText("");
                          setIsClientMenuOpen(false);
                        }}
                        onInputChange={(value, { action }) => {
                          // Only update search text on actual input, not on value select/menu close
                          if (action === "input-change") {
                            handleClientSearch(value);
                            setClientSearchText(value);
                          }
                        }}
                        inputValue={isClientMenuOpen ? clientSearchText : undefined} // ← key fix
                        onMenuOpen={() => setIsClientMenuOpen(true)}
                        onMenuClose={() => {
                          setIsClientMenuOpen(false);
                          setClientSearchText("");
                        }}
                        placeholder={clientsLoading ? props.t("Loading...") : props.t("Select")}
                        noOptionsMessage={() => (
                          clientsLoading
                            ? props.t("Loading...")
                            : clientSearchText.length > 0 && clientSearchText.length < 3
                              ? props.t("Type at least 3 characters")
                              : props.t("No options")
                        )}
                        errorMessage={props.t("Select client")}
                        options={clientOptions}
                      />
                    </Col>
                  </Row>
                </>
              )}
              {
                ["daily-net-deposit", "new-client-deposits", "summary"].includes(reportType) && <Col xs={12} md={6} lg={4}>
                  <CountryDropDown
                    defaultValue={selectedValues.country}
                    countryChangeHandler={(value) => {
                      console.log("Selected country:", value);
                      setSelectedValues(prev => ({
                        ...prev,
                        country: value?.value || "",
                      }));
                    }} />
                </Col>
              }
            </Row>
            {["summary"].includes(reportType) && <Row>
              <Col xs={12} md={6} lg={6}>
                <ClientDropDown
                  defaultValue={selectedValues.customerId}
                  clientChangeHandler={(value) => {
                    setSelectedValues({
                      ...selectedValues,
                      customerId: value.value,
                    });
                  }}
                />
              </Col>
              <Col xs={12} md={6} lg={6}>
                <div className="mb-3">
                  <SearchableComponent
                    isRequired
                    name="parentId"
                    label={props.t("IB")}
                    onChange={(e) => {
                      setSelectedValues({
                        ...selectedValues,
                        parentId: e?.value ?? "",
                      });
                    }}
                    getData={async (payload) => getClients({
                      payload: {
                        fxType: "IB",
                        ...payload
                      }
                    })?.then((res) => (res?.result?.docs || []))}
                    mapper={(doc) => (
                      {
                        label: `${doc.firstName} ${doc.lastName}`,
                        value: `${doc._id}`
                      }
                    ) || []}
                  />
                </div>
              </Col>
            </Row>}
            {["ib-total-closed-lots-by-product"].includes(reportType) && (
              <Row>
                <Col xs={12} md={4} lg={2}>
                  <div className="mb-3">
                    <SearchableComponent
                      name="ibId"
                      label={props.t("IB")}
                      value={ibValue}
                      onChange={(e) => {
                        const nextValue = e?.value ?? "";
                        setIbValue(nextValue);
                        setSelectedValues({
                          ...selectedValues,
                          ibId: nextValue,
                        });
                      }}
                      getData={async (payload) => {
                        const res = await getClients({
                          payload: {
                            fxType: "IB",
                            ...payload
                          }
                        });
                        return [ALL_IBS_OPTION, ...(res?.result?.docs || [])];
                      }}
                      mapper={(doc) => {
                        if (doc && doc.__isAll) {
                          return {
                            label: props.t("All"),
                            value: "",
                          };
                        }
                        return {
                          label: `${doc.firstName} ${doc.lastName}`,
                          value: `${doc._id}`,
                        };
                      }}
                    />
                  </div>
                </Col>
                <Col xs={12} md={4} lg={2}>
                  <AvFieldSelect
                    type="select"
                    name="productType"
                    label={props.t("Product Type")}
                    options={productTypeOptions}
                    onChange={(value) => {
                      setSelectedValues({
                        ...selectedValues,
                        productType: value,
                      });
                    }}
                  />
                </Col>
              </Row>
            )}
            {["ib-total-closed-lots-by-symbol"].includes(reportType) && (
              <Row>
                <Col xs={12} md={4} lg={2}>
                  <div className="mb-3">
                    <SearchableComponent
                      name="ibId"
                      label={props.t("IB")}
                      value={ibValue}
                      onChange={(e) => {
                        const nextValue = e?.value ?? "";
                        setIbValue(nextValue);
                        setSelectedValues({
                          ...selectedValues,
                          ibId: nextValue,
                        });
                      }}
                      getData={async (payload) => {
                        const res = await getClients({
                          payload: {
                            fxType: "IB",
                            ...payload
                          }
                        });
                        return [ALL_IBS_OPTION, ...(res?.result?.docs || [])];
                      }}
                      mapper={(doc) => {
                        if (doc && doc.__isAll) {
                          return {
                            label: props.t("All"),
                            value: "",
                          };
                        }
                        return {
                          label: `${doc.firstName} ${doc.lastName}`,
                          value: `${doc._id}`,
                        };
                      }}
                    />
                  </div>
                </Col>
                <Col xs={12} md={4} lg={2}>
                  <div className="mb-3">
                    <SearchableComponent
                      name="symbol"
                      label={props.t("Symbol")}
                      value={symbolValue}
                      onChange={(e) => {
                        const nextValue = e?.value ?? "";
                        setSymbolValue(nextValue);
                        setSelectedValues({
                          ...selectedValues,
                          symbol: nextValue,
                        });
                      }}
                      getData={async (payload) => {
                        const searchText = payload?.searchText || "";
                        const res = await getSymbols({
                          search: searchText,
                        });
                        const symbols = Array.isArray(res) ? res : [];
                        return searchText ? symbols : [ALL_SYMBOLS_OPTION, ...symbols];
                      }}
                      mapper={(item) => {
                        if (item && item.__isAll) {
                          return {
                            label: props.t("All"),
                            value: "",
                          };
                        }
                        return {
                          label: String(item),
                          value: String(item),
                        };
                      }}
                    />
                  </div>
                </Col>
              </Row>
            )}
            {["client-deposits", "client-withdrawals"].includes(reportType) && <Row className="mb-2">
              <Col xs={12} md={6} lg={4}>
                <div className="mb-3">
                  <SearchableComponent
                    name="customerId"
                    label={props.t("Client Name")}
                    onChange={(e) => {
                      setSelectedValues({
                        ...selectedValues,
                        customerId: e?.value ?? "",
                      });
                    }}
                    getData={async (payload) => getClients({ payload: { ...payload } })?.then((res) => (res?.result?.docs || []))}
                    mapper={(doc) => ({
                      label: `${doc.firstName} ${doc.lastName}`,
                      value: `${doc._id}`,
                    })}
                  />
                </div>
              </Col>
            </Row>}

            {["wallet-transactions"].includes(reportType) && (
              <Row className="mb-2">
                <Col xs={12} md={4} lg={3}>
                  <AvFieldSelect
                    name="customerId"
                    label={props.t("Client")}
                    type="select"
                    isLoading={clientsLoading}
                    isSearchable
                    onChange={(selected) => {
                      setClientSearchText("");
                      setIsClientMenuOpen(false);
                    }}
                    onInputChange={(value, { action }) => {
                      // Only update search text on actual input, not on value select/menu close
                      if (action === "input-change") {
                        handleClientSearch(value);
                        setClientSearchText(value);
                      }
                    }}
                    inputValue={isClientMenuOpen ? clientSearchText : undefined} // ← key fix
                    onMenuOpen={() => setIsClientMenuOpen(true)}
                    onMenuClose={() => {
                      setIsClientMenuOpen(false);
                      setClientSearchText("");
                    }}
                    placeholder={clientsLoading ? props.t("Loading...") : props.t("Select")}
                    noOptionsMessage={() => (
                      clientsLoading
                        ? props.t("Loading...")
                        : clientSearchText.length > 0 && clientSearchText.length < 3
                          ? props.t("Type at least 3 characters")
                          : props.t("No options")
                    )}
                    errorMessage={props.t("Select client")}
                    options={clientOptions}
                  />
                </Col>
                <Col xs={12} md={4} lg={3}>
                  <AvFieldSelect
                    name="walletType"
                    label={props.t("Transaction Type")}
                    type="select"
                    value="ALL"
                    options={[
                      {
                        label: props.t("All"),
                        value: "ALL"
                      },
                      {
                        label: props.t("Deposit"),
                        value: "DEPOSIT"
                      },
                      {
                        label: props.t("Withdrawal"),
                        value: "WITHDRAW"
                      },
                      {
                        label: props.t("Internal Transfer"),
                        value: "TRANSFER"
                      },
                      {
                        label: props.t("Cashback"),
                        value: "CASHBACK"
                      },
                    ]}
                    onChange={(value) => {
                      setSelectedValues({
                        ...selectedValues,
                        walletType: value,
                      });
                    }}
                  />
                </Col>
              </Row>
            )}
            {["payment-gateway"].includes(reportType) && (
              <Row className="mb-2">
                <Col xs={12} md={4} lg={2}>
                  <AvField
                    name="login"
                    label={props.t("Login")}
                    type="text"
                    placeholder={props.t("Enter login")}

                    // validation (fallback safety)
                    validate={{
                      pattern: { value: "^[0-9]*$" },
                      maxLength: { value: 8 }
                    }}

                    // prevent non-numbers
                    onKeyPress={(e) => {
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}

                    // enforce max length while typing
                    onInput={(e) => {
                      e.target.value = e.target.value.replace(/\D/g, "").slice(0, 8);
                    }}
                  />
                </Col>
                <Col xs={12} md={4} lg={2}>
                  <AvFieldSelect
                    name="client"
                    label={props.t("Client")}
                    type="select"
                    isLoading={clientsLoading}
                    isSearchable
                    onChange={(selected) => {
                      setClientSearchText("");
                      setIsClientMenuOpen(false);
                    }}
                    onInputChange={(value, { action }) => {
                      // Only update search text on actual input, not on value select/menu close
                      if (action === "input-change") {
                        handleClientSearch(value);
                        setClientSearchText(value);
                      }
                    }}
                    inputValue={isClientMenuOpen ? clientSearchText : undefined} // ← key fix
                    onMenuOpen={() => setIsClientMenuOpen(true)}
                    onMenuClose={() => {
                      setIsClientMenuOpen(false);
                      setClientSearchText("");
                    }}
                    placeholder={clientsLoading ? props.t("Loading...") : props.t("Select")}
                    noOptionsMessage={() => (
                      clientsLoading
                        ? props.t("Loading...")
                        : clientSearchText.length > 0 && clientSearchText.length < 3
                          ? props.t("Type at least 3 characters")
                          : props.t("No options")
                    )}
                    errorMessage={props.t("Select client")}
                    options={clientOptions}
                  />
                </Col>
                <Col xs={12} md={4} lg={2}>
                  <AvField
                    name="currency"
                    label={props.t("Currency")}
                    type="text"
                    placeholder={props.t("e.g. USD")}
                  />
                </Col>
                <Col xs={12} md={4} lg={2}>
                  <AvField
                    name="amount"
                    label={props.t("Amount")}
                    type="number"
                    placeholder={props.t("Enter amount")}
                    validate={{
                      min: { value: 0 },
                    }}
                  />
                </Col>
                <Col xs={12} md={4} lg={2}>
                  <AvFieldSelect
                    name="transactionType"
                    label={props.t("Transaction Type")}
                    type="select"
                    options={[
                      {
                        label: props.t("All"),
                        value: ""
                      },
                      {
                        label: props.t("Deposit"),
                        value: "DEPOSIT"
                      },
                      {
                        label: props.t("Withdrawal"),
                        value: "WITHDRAW"
                      },
                      {
                        label: props.t("Internal Transfer"),
                        value: "INTERNAL_TRANSFER"
                      },
                    ]}
                  />
                </Col>
                <Col xs={12} md={4} lg={2}>
                  <AvFieldSelect
                    name="accountSource"
                    label={props.t("Account Source")}
                    type="select"
                    options={[
                      {
                        label: props.t("All"),
                        value: ""
                      },
                      {
                        label: props.t("Wallet"),
                        value: "WALLET"
                      },
                      {
                        label: props.t("Forex"),
                        value: "FOREX"
                      },
                    ]}
                  />
                </Col>
              </Row>
            )}

            {["wallet-balance"].includes(reportType) && (
              <Row className="mb-2">
                <Col xs={12} md={4} lg={3}>
                  <AvFieldSelect
                    name="clientType"
                    label={props.t("Client Type")}
                    type="select"
                    value="ALL"
                    options={[
                      {
                        label: props.t("All"),
                        value: "ALL",
                      },
                      {
                        label: props.t("Trader"),
                        value: "TRADER",
                      },
                      {
                        label: props.t("IB"),
                        value: "IB",
                      },
                      {
                        label: props.t("Sub-IB"),
                        value: "SUB_IB",
                      },
                    ]}
                    onChange={(value) => {
                      setSelectedValues({
                        ...selectedValues,
                        clientType: value,
                      });
                    }}
                  />
                </Col>
                <Col xs={12} md={8} lg={6}>
                  <AvFieldSelect
                    ismulti
                    name="customerIds"
                    label={props.t("Clients")}
                    type="select"
                    isLoading={clientsLoading}
                    isSearchable
                    onInputChange={(value, { action }) => {
                      if (action === "input-change") {
                        handleClientSearch(value);
                        setClientSearchText(value);
                      }
                    }}
                    inputValue={isClientMenuOpen ? clientSearchText : undefined}
                    onMenuOpen={() => setIsClientMenuOpen(true)}
                    onMenuClose={() => {
                      setIsClientMenuOpen(false);
                      setClientSearchText("");
                    }}
                    placeholder={
                      clientsLoading
                        ? props.t("Loading...")
                        : props.t("Select clients (leave empty for all)")
                    }
                    noOptionsMessage={() => (
                      clientsLoading
                        ? props.t("Loading...")
                        : clientSearchText.length > 0 && clientSearchText.length < 3
                          ? props.t("Type at least 3 characters")
                          : props.t("No options")
                    )}
                    onChange={(values) => {
                      const joined = Array.isArray(values)
                        ? values.filter(Boolean).join(",")
                        : "";
                      setClientSearchText("");
                      setIsClientMenuOpen(false);
                      setSelectedValues({
                        ...selectedValues,
                        customerIds: joined,
                      });
                    }}
                    options={clients.map((c) => ({
                      label: `${c?.firstName || ""} ${c?.lastName || ""}`.trim(),
                      value: c._id,
                    }))}
                  />
                </Col>
              </Row>
            )}

            <Row
              className="text-center d-flex justify-content-center align-items-center my-3"
              style={{
                maxWidth: "100%",
              }}
            >
              <div
                style={{
                  maxWidth: 400,
                }}
              >
                {props.addLoading ? (
                  <Loader />
                ) : (
                  <Button
                    type="submit"
                    color="primary"
                    className="w-100 py-2"
                    disabled={props.loading || !reportType}
                  >
                    {props.t("Search")}
                  </Button>
                )}
              </div>
            </Row>
            <div className="d-flex justify-content-end gap-2">
              <DownloadFileType selectedValues={selectedValues} />
              <SendReportEmail reportValues={selectedValues} />
            </div>
          </AvForm>
        </div>
      </div>
      <div className="table-rep-plugin">
        <div className="table-responsive mb-0" data-pattern="priority-columns">
          {props.children}
          <CustomPagination
            {...props.reportsReducer}
            setSizePerPage={setSizePerPage}
            sizePerPage={sizePerPage}
            onChange={paginationLoad}
          />
        </div>
      </div>
    </React.Fragment>
  );
}

const mapStateToProps = (state) => ({
  loading: state.reportsReducer.loading || false,
  salesAgent: state.usersReducer.salesAgent || [],
  reportsReducer: state.reportsReducer || {},
  clientDetails: state.clientReducer.clientDetails,
  userData: state.Profile.userData || {},
});
export default connect(mapStateToProps, null)(withTranslation()(UsersAddModal));
